<template>
    <div class="new-game">
        <div class="new-game__title-wrap">
            <div @click="toHome"
                 class="new-game__arrow-back">
                <img class="new-game__arrow-back-img"
                     src="../assets/icon/arrow-left.svg"
                     alt="">
            </div>
            <div class="new-game__title">Настройки игры</div>


        </div>
        <div class="new-game__plate">

            <div class="new-game__words-list">
                <div class="words-list">
                    <div class="words-list__title">Слова</div>
                    <label class="words-list__item"
                           v-for="(item,index) in wordsChunksSets"
                           :key="index+'chunk'">
                        <input type="checkbox"
                               @change="localUpdChunck"
                               :value="item.title"
                               v-model="localWordsChunks">
                        <span class="words-list__item-checkmark"></span>
                        <span class="words-list__item-label"> {{item.title}}</span>
                    </label>

                </div>
            </div>
            <div class="new-game__counter-row">
                <div class="new-game__counter">
                    <div class="new-game__counter-title">Секунд на ответ</div>
                    <div class="counter">
                        <div class="counter__btn"
                             @click="setTime(currentTimer-15<=0?currentTimer:currentTimer-15)">-
                        </div>
                        <div class="counter__timer">{{currentTimer}}</div>
                        <div class="counter__btn"
                             @click="setTime(currentTimer+15)">+
                        </div>
                    </div>
                </div>
                <div class="new-game__counter">
                    <div class="new-game__counter-title">Очков до победы</div>
                    <div class="counter">
                        <div class="counter__btn"
                             @click="setCountForWiner(countForWin-5<=0?countForWin:countForWin-5)">-
                        </div>
                        <div class="counter__timer">{{countForWin}}</div>
                        <div class="counter__btn"
                             @click="setCountForWiner(countForWin+5)">+
                        </div>
                    </div>
                </div>

            </div>
            <div class="new-game__team-select">
                <div class="new-game__team-select-title">Команды</div>
                <div class="team-select">
                    <div class="team-select__team-item"
                         v-for="(item, index) in players"
                         v-bind:key="item.id"
                         @click="settingIsShown=index">

                        <img class="team-select__team-item-img"
                             :src="playersPreset[item.image].image"
                             alt="">
                        {{item.title}}

                        <div class="team-select__team-item-del"
                             v-if="players.length>=3"
                             @click.stop="delPlayer(index)"
                        >+
                        </div>
                    </div>
                    <div v-if="this.players.length < 5"
                         class="team-select__add-team-item"
                         @click="newTeam()"
                    >+
                    </div>
                </div>
            </div>
            <div class="new-game__action-btn">
                <div class="action-btn">

                    <GoBtn @click="startGame">Начать игру</GoBtn>
                </div>
            </div>
            <transition name="bounce">
                <div class="settings-plate__wrap"
                     v-if="settingIsShown!==null">
                    <div class="settings-plate__backdrop"
                         @click="settingIsShown=null"></div>
                    <div class="settings-plate">
                        <div class="settings-plate__title-wrap">
                            <div class="settings-plate__title">Выберите команду</div>
                            <div class="settings-plate__title-close "
                                 @click="settingIsShown=null">x
                            </div>
                        </div>
                        <div class="settings-plate__avatears-wrap">
                            <AvatarSlider
                                    :avatarList="playersPreset"
                                    :teamIndex="settingIsShown"
                                    :preSelectedAvatar="null"
                                    @selectAvatar="settingIsShown=null"
                            ></AvatarSlider>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    import AvatarSlider from "../components/AvatarSlider";
    import {mapGetters, mapActions} from 'vuex';


    import GoBtn from "../components/GoBtn";

    export default {
        components: {
            GoBtn,

            AvatarSlider
        },
        mounted: function () {
            this.loadingData();
            this.localWordsChunks = this.wordsChunksSelected
        },
        data: function () {
            return {
                lastIndex: 3,
                settingIsShown: null,
                localWordsChunks: []
            }
        },
        computed: {
            ...mapGetters([
                'playersPreset',
                'players',
                'wordsSet',
                'wordsChunksSets',
                'wordsChunksSelected',
                'currentTimer',
                'countForWin'
            ])
        },
        methods: {
            localUpdChunck() {
                this.updChunck(this.localWordsChunks)
            },
            startGame() {

                if (this.localWordsChunks.length > 0) {
                    this.$router.push('your-move')
                } else {
                    alert('Выберите слова')
                }

            },
            toHome() {
                this.$router.push('/')
            },
            newTeam() {


                this.addPlayer({
                    title: this.playersPreset[this.lastIndex].title,
                    image: this.lastIndex,
                    score: 0,
                    id: Math.random(),
                    resolved: [],
                    unresolved: [],
                });
                this.lastIndex++

            },

            ...mapActions([
                'addPlayer',
                'delPlayer',
                'loadingData',
                'updChunck',
                'setTime',
                'setCountForWiner'
            ])
        }
    }
</script>
<style lang="scss">
    .settings-plate {

        position: fixed;
        bottom: 0;
        left: 0;
        background: #fff;
        width: 100vw;
        &__backdrop {
            width: 100vw;
            height: 100vh;
            position: fixed;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, .1);
        }

        &__title-wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 16px 0;
            font-size: 20px;
            font-weight: 900;
            color: #333;
        }
        &__title-close {
            opacity: .2;
        }
    }

    .team-select {
        display: flex;
        width: 100%;
        max-width: 100%;
        overflow-x: scroll;

        &__add-team-item {
            width: 60px;
            flex: 0 0 60px;
            height: 135px;
            border: 1px solid #eee;
            border-radius: 20px;
            display: flex;
            align-items: center;
            background: #f2f2f2;
            font-weight: 900;
            font-size: 24px;
            justify-content: space-around;
            color: #999;

        }
        &__team-item {
            width: 120px;
            height: 135px;
            flex: 0 0 120px;
            border: 1px solid #eee;
            border-radius: 20px;
            margin-right: 12px;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 12px;
            color: #666;
            position: relative;

            &:first-child {
                margin-left: 30px;
            }
            &-img {
                max-height: 77px;
                max-width: 77px;
                margin-bottom: 12px;
            }
            &-del {
                position: absolute;
                right: 10px;
                top: 1px;
                font-weight: 900;
                font-size: 24px;
                transform: rotate(45deg);
                opacity: .2;
            }
        }
    }

    .new-game {
        height: 100%;
        display: flex;
        flex-direction: column;
        min-height: 100vh;

        &__title-wrap {
            display: flex;
            align-items: center;
            margin-top: 20px;
        }
        &__arrow-back {
            width: 52px;
            height: 52px;
            cursor: pointer;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0.04);
            display: flex;
            align-items: center;
            justify-content: space-around;
            &-img {
                width: 20px;
            }

        }
        &__title {
            font-size: 28px;
            font-weight: 700;
            text-shadow: 0 2px 2px rgba(0, 0, 0, .1);
            color: #FFFFFF;
        }

        &__plate {
            background: #fff;
            height: auto;
            bottom: 0;
            margin-top: 10px;
            width: 100%;
            padding: 30px;
            border-radius: 40px 40px 0 0;
            position: relative;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            box-shadow: 0 -10px 50px rgba(0, 0, 0, 0.1);
        }
        &__counter {
            margin-right: 20px;
            display: inline-block;
            &:last-child {
                margin-right: 0;
            }
        }
        &__counter-row {

            margin-bottom: 20px;
        }
        &__team-select {
            margin: 0 -30px 40px;
        }
        &__team-select-title {
            margin-left: 30px;
        }
        &__action-btn {
            margin-top: auto;
        }

    }

    .counter {
        display: inline-flex;
        border-radius: 20px;
        border: 1px solid #eee;
        position: relative;
        margin-bottom: 12px;
        font-size: 16px;
        font-weight: 900;
        color: #999;
        height: 49px;
        user-select: none;

        padding: 8px;
        &__btn {
            height: 32px;
            width: 32px;
            background: #f2f2f2;
            border-radius: 13px;
            display: flex;
            align-items: center;
            justify-content: space-around;
        }
        &__timer {
            display: flex;
            align-items: center;
            padding: 15px;
        }
    }

    .words-list {
        margin-bottom: 20px;
    }

    .words-list__item {
        display: inline-block;
        border-radius: 20px;
        border: 1px solid #eee;
        position: relative;
        padding: 13px 14px 12px 49px;
        margin-bottom: 12px;
        font-size: 16px;
        font-weight: 900;
        color: #999;
        height: 49px;
        user-select: none;
        margin-right: 12px;
    }

    /* Hide the browser's default checkbox */
    .words-list__item input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .words-list__item-checkmark {
        position: absolute;
        top: 8px;
        left: 8px;
        height: 32px;
        width: 32px;
        border-radius: 13px;
        background-color: #f2f2f2;
    }

    /* On mouse-over, add a grey background color */
    .words-list__item:hover input ~ .words-list__item-checkmark {
        background-color: #f2f2f2;
    }

    /* When the checkbox is checked, add a blue background */
    .words-list__item input:checked ~ .words-list__item-checkmark {
        background-color: #94C94B;
    }

    .words-list__item input:checked ~ .words-list__item-label {
        color: #94C94B;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .words-list__item-checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .words-list__item input:checked ~ .words-list__item-checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .words-list__item .words-list__item-checkmark:after {
        left: 11px;
        top: 3px;
        width: 6px;
        height: 17px;
        border: solid white;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
    }


</style>
